var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    transform: "translate(-160 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 96,
    height: 96,
    rx: 48,
    transform: "translate(160 56)",
    fill: "#f0edf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Packages",
    transform: "translate(192 86.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10280",
    "data-name": "Path 10280",
    d: "M17.553,1.552,29.713,7.5a2.967,2.967,0,0,1,1.687,2.66V24.321a2.967,2.967,0,0,1-1.687,2.66l-12.16,5.945a3.1,3.1,0,0,1-2.721,0L2.672,26.982A2.966,2.966,0,0,1,1,24.306V10.157A2.967,2.967,0,0,1,2.687,7.5l12.16-5.945a3.1,3.1,0,0,1,2.706,0Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#6a55a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10281",
    "data-name": "Path 10281",
    d: "M1.32,7.453l14.714,7.194L30.747,7.453M16.034,32.126V14.647M8.434,3.5l15.2,7.431",
    transform: "translate(0.166 1.098)",
    fill: "none",
    stroke: "#6a55a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel1);
export default __webpack_public_path__ + "static/media/hotel-1.8945e622204fd4ec066b1981d1f51ce2.svg";
export { ForwardRef as ReactComponent };